// tslint:disable max-line-length
import * as Constants from "Data/Constants";
import {NEW_ORLEANS as VO} from "Data/VO";
import type { ILocationConfig } from "Interfaces/ILocationConfig";

export const NewOrleansConfig: ILocationConfig = {
  city: "New Orleans",
  country: "USA",
  interior: {
    width: 1664,
    itemslist: {
       give: {
          bg: [
              { filename: "streetlamp", x: 1183 - (1024 / 2) - 328, y: 292.75 - (768 / 2) - ((667 - 585.5) / 2), dontAnimateIn: true},
              { filename: "clipboard", x: -20, y: -84 },
          ],
          ICON_SIZE: 125,
          ICON_SPACING: 1,
          columns: 4,
          floatingItemsY: -150,
          width: 505,
          highlightFloatingItems: false,
          animateIn: "slideInFromRight",
      },
      return: {
        width: 0,
        height: 0,
        highlightFloatingItems: true,
        floatingItemsY: -250,
        ICON_SIZE: 125,
        ICON_SPACING: 0,
        itemslots: [
          {
            x: 0,
            y: 0,
            width: 758.5,
            height: 422.5,
            acceptsMultiple: true,
            bg: [
              {filename: "neworleans-target-ring", x: 0, y: 150},
              {filename: "van", x: 0, y: -40},
            ],
            hideIconImmediately: true,
            animateOnDrop: "squash",
            dropSFX: ["impact-van1", "impact-van2", "impact-van3"],
            // scaleUpOnDragOver: true,
            musicnotes: true,
          },
        ],
        animateOut: "none",
      },
    },
    bg: { filename: "no-int-bg1" },
  },
  exterior: {
    bg: [
      { filename: "no-ext-bg1", x: 0, y: 0 },
      { filename: "no-ext-bg2", x: 2048, y: 0 },
    ],
    margin: {
      left: 0,
      right: 0,
    },
    width: 3072,
  },
  items: {
    "clarinet": {
        name: "Clarinet",
        sprite: "clarinet-full",
        sprite_hat: "clarinet-full",
        icon_ext: "clarinet-on",
        icon_int_give: "clarinet-full",
        icon_int_return: "clarinet-full",
        vo: {
          found: VO.IN6B,
          returned: VO.IN6A,
          fact: VO.FN9,
        },
    },
    "drum-sticks": {
        name: "Drum Sticks",
        sprite: "drum-sticks-full",
        sprite_hat: "drum-sticks-full",
        icon_ext: "drum-sticks-on",
        icon_int_give: "drum-sticks-full",
        icon_int_return: "drum-sticks-full",
        vo: {
          found: VO.IN10B,
          returned: VO.IN10A,
        },
    },
    "trumpet": {
        name: "Trumpet",
        sprite: "trumpet-full",
        sprite_hat: "trumpet-full",
        icon_ext: "trumpet-on",
        icon_int_give: "trumpet-full",
        icon_int_return: "trumpet-full",
        vo: {
          found: VO.IN4B,
          returned: VO.IN4A,
          fact: VO.FN11,
        },
    },
    "trombone": {
        name: "Trombone",
        sprite: "trombone-full",
        sprite_hat: "trombone-full",
        icon_ext: "trombone-on",
        icon_int_give: "trombone-full",
        icon_int_return: "trombone-full",
        vo: {
          found: VO.IN7B,
          returned: VO.IN7A,
          fact: VO.FN7,
        },
    },
    "sousaphone": {
        name: "Sousaphone",
        sprite: "sousaphone-full",
        sprite_hat: "sousaphone-full",
        icon_ext: "sousaphone-on",
        icon_int_give: "sousaphone-full",
        icon_int_return: "sousaphone-full",
        vo: {
          found: VO.IN2B,
          returned: VO.IN2A,
          fact: VO.FN5,
        },
    },
    "saxophone": {
        name: "Saxophone",
        sprite: "saxophone-full",
        sprite_hat: "saxophone-full",
        icon_ext: "saxophone-on",
        icon_int_give: "saxophone-full",
        icon_int_return: "saxophone-full",
        vo: {
          found: VO.IN3B,
          returned: VO.IN3A,
          fact: VO.FN10,
        },
    },
    "guitar": {
        name: "Guitar",
        sprite: "guitar-full",
        sprite_hat: "guitar-full",
        icon_ext: "guitar-on",
        icon_int_give: "guitar-full",
        icon_int_return: "guitar-full",
        vo: {
          found: VO.IN5B,
          returned: VO.IN5A,
        },
    },
    "flute": {
        name: "Flute",
        sprite: "flute-full",
        sprite_hat: "flute-full",
        icon_ext: "flute-on",
        icon_int_give: "flute-full",
        icon_int_return: "flute-full",
        vo: {
          found: VO.IN9B,
          returned: VO.IN9A,
        },
    },
    "bass": {
        name: "Bass",
        sprite: "bass-full",
        sprite_hat: "bass-full",
        icon_ext: "bass-on",
        icon_int_give: "bass-full",
        icon_int_return: "bass-full",
        vo: {
          found: VO.IN8B,
          returned: VO.IN8A,
          fact: VO.FN8,
        },
    },
    "drum-kit": {
        name: "Drum Kit",
        sprite: "drum-kit-full",
        sprite_hat: "drum-kit-full",
        icon_ext: "drum-kit-on",
        icon_int_give: "drum-kit-full",
        icon_int_return: "drum-kit-full",
        vo: {
          found: VO.IN1B,
          returned: VO.IN1A,
          fact: VO.FN6,
        },
    },
  },
  payoffs: {
    payoff1: {name: "Payoff 1"},
  },
  hidingspots: {
    "us-flag": {foreground: {sprite: "us-flag", x: 1195.5, y: 16}, hitarea: {x: 1337, y: 159}},
    "bench": {foreground: { sprite: "bench", x: 1307.5, y: 355.5 }, hitarea: {x: 1439.5, y: 393.5}},
    "lamp-post": {foreground: {sprite: "lamp-post", x: 1510, y: 132}, hitarea: {x: 1545.5, y: 321.5}},
    "orangebuilding": {
        foreground: [
            {sprite: "orangebuilding-front", x: 602, y: 140.5},
        ],
        hitarea: {x: 923.5, y: 326.75},
    },
    "orangebuilding-flower1": {
        foreground: {sprite: "orangebuild-flower-1", x: 577.5, y: 44},
        hitarea: {x: 641.25, y: 94},
    },
    "orangebuilding-flower2": {
        foreground: {sprite: "orangebuild-flower-2", x: 794, y: 41.5},
        hitarea: {x: 852, y: 93.75},
    },
    "orangebuilding-flower3": {
        foreground: {sprite: "orangebuild-flower-2", x: 955, y: 48.5},
        hitarea: {x: 1011, y: 113},
    },
    "orangebuilding-flower4": {
        foreground: {sprite: "orangebuild-flower-1", x: 1133, y: 57},
        hitarea: {x: 1196.75, y: 107},
    },
    "urn-small": {
        background: {sprite: "urn-small-back", x: 2810, y: 258},
        foreground: {sprite: "urn-small-front", x: 2846, y: 309.5},
        hitarea: { x: 2891.5, y: 352},
    },
    "yellowbuilding": {
        background: [
            {sprite: "yellowbuilding-back", x: 1663.5, y: 460.5 - 500.7, halfSize: true},
            {sprite: "yellowbuilding-door", x: 2133, y: 243.5},
        ],
        foreground: {sprite: "yellowbuilding-front", x: 1585.5, y: 517 - 557, halfSize: true},
        hitarea: {  x: 2236.25, y: 343.5},
    },
    "doorway-potter-1": {foreground: {sprite: "doorway-potter-1", x: 256.5, y: 301}, hitarea: {x: 310.75, y: 380.75}},
    "doorway-potter-2": {foreground: {sprite: "doorway-potter-2", x: 569, y: 288.5}, hitarea: {x: 622.75, y: 379.25}},
    "trashcan": {foreground: {sprite: "trashcan", x: 2602, y: 381}, hitarea: {x: 2658, y: 451}},
    "crowd": {foreground: {sprite: "crowd", x: 638, y: 305.5}, hitarea: {x: 840, y: 393.5}},
    "car1": {foreground: {sprite: "car-1", x: 346.5 - 391.7, y: 412}, hitarea: {x: 163.5, y: 452.5 }},
    "car2": {foreground: {sprite: "car-2", x: 1546, y: 425}, hitarea: {x: 1725, y: 546.5}},
    "car3": {foreground: {sprite: "car-3", x: 2883, y: 445.5}, hitarea: { x: 2996.5, y : 558.5}},
    "railing": {
        foreground: [
            {sprite: "railing-1", x: 0, y: 610, halfSize: true},
            {sprite: "railing-2", x: 2048, y: 610},
        ],
        hitarea: {x: 2048, y: 659},
    },
    "lightpost-burbon": {foreground: {sprite: "lightpost-burbon", x: 1636, y: 71}, hitarea: {x: 1819.5, y: 685.5}},
    "sign": { foreground: {sprite: "sign", x: 1366.5, y: 587.5}, hitarea: { x: 1484.5, y: 662.5}},
    "table1": {
        foreground: { sprite: "table1", x: 158, y: 630.5}, hitarea: { x: 398.5, y: 664.5},
        background: [
            {sprite: "stool", x: 123.5, y: 662.5},
            {sprite: "stool", x: 427.5, y: 680},
        ],
    },
    "table2": {
        foreground: { sprite: "table2", x: 671, y: 630.5}, hitarea: {x: 854, y: 662.5},
        background: [
            { sprite: "stool", x: 671, y: 669.5},
            { sprite: "stool", x: 975, y: 669.5},
        ],
    },
    "urn1": {
        background: {sprite: "urn-back", x: 2187, y: 498},
        foreground: {sprite: "urn-front", x: 2230, y: 560},
        hitarea: {x: 2285, y: 612},
    },
    "urn2": {
        background: {sprite: "urn-back", x: 2738.5, y: 498},
        foreground: {sprite: "urn-front", x: 2781.5, y: 560},
        hitarea: { x: 2836, y: 611},
    },
    "metaltable": {
        background: {sprite: "metaltable-back", x: 2367.5, y: 584.5},
        foreground: {sprite: "metaltable-front", x: 2452.5, y: 641},
        hitarea: {x: 2575.75, y: 704.5},
    },
    "park-bench": {
        foreground: {sprite: "park-bench", x: 3171 / 2, y: 1247 / 2},
        hitarea: {x: 3639 / 2, y: 1371 / 2},
    },
  },
  npc: {
    name: "Dexter",
    poses: {
      neutral: {sprite: "npc-dexter-neutral"},
      excited: {sprite: "npc-dexter-excited", position: {x: -48, y: 0}},
    },
  },
  vo: {
    give_quest: [VO.N1],
    show_items: [VO.N2, Constants.VO_SPACING, VO.N3],
    give_quest_idle: [VO.N4, VO.N5],
    return_items: [VO.N8, Constants.VO_SPACING, VO.N9],
    return_items_idle: [VO.N9],
    exterior: [VO.N6, Constants.VO_SPACING, VO.N7],
    exterior_idle: [VO.FN1, VO.FN2, /* VO.FN3, */ VO.FN4],
    all_items_returned_idle: [VO.N13],
  },
  narratives: [
    {
      variations: [
// Level 1
        {
          hiddenitems: [
            {hidingspot: "table1", item: { id: "drum-kit", rotation: 12.63, scale: 0.7289, position: {x: 12.75, y: 34.25 - 30}}},
            {hidingspot: "crowd", item: { id: "sousaphone", rotation: -18.91, scale: 0.6095, position: {x: -66.5, y: 6}}},
            {hidingspot: "car2", item: { id: "saxophone", rotation: 180 - 156.90, scale: 0.6227, flipX: true, position: {x: 265.75 + 30, y: -44.75}}},
            {hidingspot: "urn2", item: { id: "trumpet", rotation: 18.82, scale: 0.5104, position: {x: 11.75, y: -49.5}}},
          ],
          itemslist: {
            give: {
              columns: 2,
            },
          },
          vo: {
            all_items_returned: [VO.N10, Constants.VO_SPACING, VO.N13],
          },
        },
// Level 2
        {
            hiddenitems: [
              {hidingspot: "car1", item: { id: "guitar", rotation: 180 - 142.98, scale: 0.6354, flipX: true, position: {x: -125.5 + 40, y: -30 - 40}}},
              {hidingspot: "table2", item: { id: "trumpet", rotation: 0, scale: 0.5898, position: {x: 40.25 + 90, y: 14.25}}},
              {hidingspot: "us-flag", item: { id: "clarinet", rotation: -3.50, scale: 0.7113, position: {x: -24.5, y: -94.5}, flipX: true}},
              {hidingspot: "park-bench", item: { id: "trombone", rotation: 41.88, scale: 0.5898, position: {x: 85, y: 48.75 - 15}}},
              {hidingspot: "trashcan", item: { id: "bass", rotation: -10.39, scale: 0.6983, position: {x: 30.25, y: -51}}},
            ],
            itemslist: {
              give: {
                columns: 3,
              },
            },
            vo: {
              all_items_returned: [VO.N11, Constants.VO_SPACING, VO.N13],
            },
        },
// Level 3
        {
            hiddenitems: [
              {hidingspot: "car1", item: { id: "drum-kit", rotation: -14.49, scale: 0.652, position: {x: -90 + 20, y: 29 - 20}}},
              {hidingspot: "orangebuilding-flower3", item: { id: "drum-sticks", rotation: 112.71 - 180, scale: 0.6, flipX: true, position: {x: -18.75, y: 11}}},
              {hidingspot: "sign", item: { id: "saxophone", rotation: -6.70, scale: 0.6524, position: {x: -51.75, y: -0.25}}},
              {hidingspot: "urn1", item: { id: "flute", rotation: -7.25, scale: 0.7, position: {x: 10 + 5, y: -13 - 25}}},
              {hidingspot: "car3", item: { id: "guitar", rotation: 50.30, scale: 0.709, position: {x: -15.5, y: -5.25}}},
            ],
            itemslist: {
              give: {
                columns: 3,
              },
            },
            vo: {
              all_items_returned: [VO.N12, Constants.VO_SPACING, VO.N13],
            },
        },
// Level 4
         {
            hiddenitems: [
              {hidingspot: "car1", item: { id: "trombone", rotation: 65.65, scale: 0.5333, position: {x: 55.5, y: 50.50}}},
              {hidingspot: "crowd", item: { id: "bass", rotation: 179.76 - 180, scale: 0.5621, flipX: true, position: {x: 185.25, y: 18.75 - 50}}},
              {hidingspot: "bench", item: { id: "trumpet", rotation: 4.45, scale: 0.4499, position: {x: -91.75, y: 6.25}}},
              {hidingspot: "car2", item: {id: "clarinet", rotation: 119.88 - 180, scale: 0.6516, flipX: true, position: {x: -92, y: 88.75}}},
              {hidingspot: "trashcan", item: { id: "flute", rotation: 135.35, scale: 0.5984, position: {x: 40.75, y: -20.75}}},
              {hidingspot: "car3", item: { id: "sousaphone", rotation: 180 - 115.97, scale: 0.6541, flipX: true, position: {x: 35.75, y: -23.5}}},
            ],
            itemslist: {
              give: {
                columns: 3,
              },
            },
            vo: {
              all_items_returned: [VO.N10, Constants.VO_SPACING, VO.N13],
            },
        },
// Level 5
        {
            hiddenitems: [
              {hidingspot: "car1", item: { id: "trumpet", rotation: 108.06, scale: 0.6795, position: {x: 98.5, y: 60.75}}},
              {hidingspot: "table2", item: { id: "drum-kit", rotation: -7.82, scale: 0.665, position: {x: 120, y: 140.5}}},
              {hidingspot: "crowd", item: { id: "flute", rotation: 106.75 - 180, scale: 0.5653, flipX: true, position: {x: 156, y: 81.5}}},
              {hidingspot: "us-flag", item: { id: "trombone", rotation: 112.88, scale: 0.4886, position: {x: 23.25, y: -39.75}}},
              {hidingspot: "park-bench", item: { id: "bass", rotation: 123.65 - 180, scale: 1, flipX: true, position: {x: -37, y: 35.5}}},
              {hidingspot: "car2", item: { id: "guitar", rotation: 180 - 6.42, scale: 0.6698, flipX: true, position: {x: 254, y: -21.75}}},
              {hidingspot: "urn1", item: { id: "drum-sticks", rotation: -23.38, scale: 0.6, position: {x: -1.25, y: -17.75 - 30}}},
              {hidingspot: "urn-small", item: { id: "clarinet", rotation: -9.47, scale: 0.4604, position: {x: 11.25, y: -13.5}}},
            ],
        },
      ],
      payoff: "payoff1",
      vo: {
        all_items_returned: [VO.N11, Constants.VO_SPACING, VO.N13],
      },
    },
  ],
  bgm: "LATW_1175_happy_pacer_zydeco_jazz_New_Orleans_AP-01_extended",
};
